<template>

<div class="tag" v-on:click="onClick">

    <div class="tag-info">
    
        <div class="tag-name">{{ tag.text }}</div>
    
        <div class="tag-tags">
        
            <div class="tag-tags-item is-private" v-if="!tag.public">Private</div>

            <div class="tag-tags-item is-collection" v-if="tag.context === 1">Collection</div>

            <div class="tag-tags-item is-ratings" v-if="tag.context === 2">Ratings</div>

            <div class="tag-tags-item is-plays" v-if="tag.context === 3">Plays</div>
        
        </div>
    
    </div>

    <div class="tag-color" :style="{backgroundColor: tag.colour, color: tag.fore}">

        {{ tag.attachments }}

    </div>

</div>

</template>

<script>

export default {

	props: ['tag'],

    methods: {

        onClick: function() {

            this.$pubsub.$emit('open.modal', {
				id: 'tagEdit',
				tag: this.tag.id
			})

        }

    }

}

</script>

<style scoped>

.tag {
    padding: 10px 20px 10px 20px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    cursor: pointer;
    display: grid;
	user-select: none;
    grid-gap: 10px;
    grid-template-columns: 1fr 40px;
    align-items: center;
}

.is-mobile .tag {
    padding: 10px;
    border-bottom: 1px solid #eee;
}

.is-desktop .tag:hover {
    background-color: rgba(255, 255, 255, 0.1);
    border-bottom: 1px solid transparent;
}

.tag-color {
    width: 40px;
    height: 40px;
    border-radius: 4px;
    line-height: 40px;
    background-color: #133445;
    color: #fff;
    text-align: center;
    font-size: 16px;
    font-weight: 500;
}

.tag-name {
    font-size: 16px;
    font-weight: 400;
    color: #fff;
}

.is-mobile .tag-name {
    color: #343434;
}

.tag-tags {
    display: flex;
    gap: 4px;
    margin-top: 3px;
}

.tag-tags-item {
    border-radius: 4px;
    padding: 2px 4px;
    font-size: 12px;
    font-weight: 400;
    text-transform: lowercase;
    color: #0a2b3d;
    background-color: rgba(255, 255, 255, 0.25);
}

.is-mobile .tag-tags-item {
    background-color: rgba(0, 0, 0, 0.25);
}

.tag-metric {
    color: #fff;
    font-size: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 32px;
}

.tag-metric-value {
    font-size: 20px;
    font-weight: 500;
    margin-bottom: 1px;
}

.tag-metric-label {
    font-size: 12px;
    font-weight: 400;
    opacity: 0.6;
}

</style>